module.exports = __webpack_public_path__ + "static/media/lightning-logo-transparent.80ce1325.png";